package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
enum class GamePhase {
    SETUP,      // Setting up players and game configuration
    PLAYING,    // Active gameplay
    PAUSED,     // Game paused
    FINISHED    // Game completed
}
